/**
 * @fileoverview
 * Este archivo define y exporta varios contextos globales para el estado de la aplicación.
 * Los contextos permiten compartir datos entre componentes sin necesidad de pasar props manualmente.
 */

import { createContext } from 'react';
import { settings } from '../config';

/**
 * @constant AppContext
 * @description
 * Contexto principal de la aplicación que proporciona configuraciones globales como tema, disposición del navbar, etc.
 * Se inicializa con las configuraciones por defecto del archivo `config.js`.
 */
const AppContext = createContext(settings);

/**
 * @constant ProductContext
 * @description
 * Contexto que mantiene el estado global de productos en la aplicación.
 * @default { products: [] }
 */
export const ProductContext = createContext({ products: [] });

/**
 * @constant CourseContext
 * @description
 * Contexto que gestiona cursos disponibles y cursos principales.
 * @default { courses: [], primaryCourses: [] }
 */
export const CourseContext = createContext({ courses: [], primaryCourses: [] });

/* Otros contextos que puedes activar si los necesitas:

// export const EmailContext = createContext({ emails: [] });

// export const FeedContext = createContext({ feeds: [] });

// export const AuthWizardContext = createContext({ user: {} });

// export const ChatContext = createContext();

// export const KanbanContext = createContext({
//     KanbanColumns: [],
//     kanbanTasks: []
// });

*/

export default AppContext;